<template>
  <div class="header">
   <div class="container" :class="[hasBg?'has_bg':'']">
    <div class="page_width">
       <!-- pc header -->
      <div class="header_top flex_sb hidden-sm-and-down">
        <div class="header_logo pointer" @click="toPage('index')">
          <div class="header_logo_group">
            <img src="../assets/image/logo.png" alt="">
          </div>
        </div>
       
        <div class="header_menu">
         <div class="menu_list flex">
          <div class="menu_tab pointer" :class="[i.id=='7'?'bg_btn color1':'',i.path==routeName?'color8':'']" v-for="(i) in  menuList" :key="i.id" @click="toPage(i.path)" @mouseenter="getMineMenu(i)" @mouseleave="removeMinMenu(i)">
            {{ i.title }} 
            <span class="icon-down-line-free iconfont" v-if="i.child"></span>
          <div class="min_menu" v-if="i.child">
            <transition name="el-zoom-in-top">
              <div class="min_menu_list" v-show="child_drawer&&child_drawer_id == i.id">
                <div class="min_menu_tab pointer flex_center_start" v-for="(child) in  i.child" :key="child.id"  @click.stop="toPage(child.path)" @mouseenter="child_id = child.id" @mouseleave="child_id = null"><img :src="child_id==child.id?child.icons.active:child.icons.unActive" alt="" v-if="child.icons" class="w-24px h-24px mr-6">{{ child.title }}</div>
              </div>
            </transition>
          </div>
          </div>
         </div>
        </div>
        <div style="flex:1"></div>
      </div>
      <!-- mobile header -->
      <div class="mobile_header flex_sb hidden-md-and-up">
        <div class="header_logo pointer" @click="toPage('index')">
          <div class="header_logo_group">
            <img src="../assets/image/logo.png" alt="">
          </div>
        </div>
        <div class="menu_icon iconfont icon-menu-line flex_center" @click="drawer=!drawer"></div>
        <div class="mobile_menu">
          <transition name="el-zoom-in-top">
            <div class="mobile_menu_list" v-show="drawer">
              <div class="mobile_menu_tab pointer color1" v-for="(i) in  menuList" :key="i.id"  @click="toMobilPage(i)" >{{ i.title }}
                <transition name="el-zoom-in-top" v-if="i.child">
                  <div class="min_menu_list" v-show="child_drawer_id == i.id" >
                    <div class="min_menu_tab pointer" v-for="(chi) in  i.child" :key="chi.id"  @click="toPage(chi.path)" >{{ chi.title }}</div>
                  </div>
                </transition>
              </div>
              
            </div>
          </transition>
        </div>
      </div>
      
    </div>
   </div>
 
   
  </div>
</template>

<script>

export default {
  data () {
    return {
      child_drawer:false,
      child_drawer_id:null,
      child_mobile_drawer:false,
      drawer:false,
      child_id:null,
      page:'',
      routeName:'',
      hasBg:false
    }
  },
  methods: {
    toPage(e){
     
      this.drawer = false
      this.$router.push('/'+e)
    },
    toMobilPage(item){
      if(item.child && !item.path){
        if( this.child_drawer_id == item.id){
           this.child_drawer_id = null
        }else{
           this.child_drawer_id = item.id
        }
       
        return
      }
      this.child_drawer_id = null
      this.drawer = false
      this.$router.push('/'+item.path)
    },
    getMineMenu(item){
      if(item.child){
        this.child_drawer_id = item.id
        this.child_drawer = true
      }
    },
    removeMinMenu(item){
      if(item.child){
        this.child_drawer_id = null
        this.child_drawer = false
      }
    },
  },
  created(){
   this.routeName = this.$route.name
   if(this.$route.meta?.header_bg){
        this.hasBg = true
      }else{
        this.hasBg = false
      }
  },
  computed:{
    menuList(){return this.$store.state.menuList}
  },
  watch: {
    '$route' (to, from) {
      let name = to.name
      this.routeName = name
      if(to.meta?.header_bg){
        this.hasBg = true
      }else{
        this.hasBg = false
      }
      console.log('routeName',to)

    }
  },
}
</script>

<style lang="scss" >
.header{
  width:100%;
  position: relative;
  z-index: 99;
  .has_bg{
    background:#131625;
  }
  /* pc header */
  .header_top{
    width:100%; 
    height: 80px;
    .header_logo{
     
      .header_logo_group{
        height: 80px;
        // width: 180px;
        // background:$theme_color5;
        // padding:10px 60px 10px 0px;
        // clip-path: polygon(0% 0%, 100% 0%, 70% 100%, 0% 100%);
      } 
     
      
    }
    .header_menu{
     margin-left: 80px;
      .menu_list{
        // padding:30px 20px 30px 60px;
        // background:$theme_color5;
        // clip-path: polygon(100% 100%, 100% 0%, 8% 0%,0% 100%);
        .menu_tab{
            color:$theme_color1;
            font-size: 20px;
            padding:4px 10px;
            position: relative;
            &:last-child{
              margin-left:20px;
            }
            >span{
              display: inline-block;
              font-weight: bold;
              transition: all 0.3s ease;
              
            }
            &:hover{
              >span{
                transform: rotate(-90deg);
              }
              transition: all 0.3s ease;
              color:$theme_color3;
            }
            .min_menu{
              position: absolute;
              top:20px;
              left:10px;
              min-width: 230px;
              width: min-content;
              overflow: hidden;
              padding-top:30px;
              text-align: left;
              .min_menu_list{
                
                color:$theme_color2;
                overflow: hidden;
                font-size: 16px;
               .min_menu_tab{
                transition: all 0.3s ease;
                padding:3px 8px;
             
                background:$theme_color1;
                &:first-child{
                  border-radius: 12px 12px 0 0;
                  padding-top:8px;
                }
                &:last-child{
                  border-radius:0 0 12px 12px;
                 padding-bottom:8px;
                }
                
                &:hover{
                  color:$theme_color3;

                }
               }
                
              }
            }
        }
        
      }
    }
  }
  /* mobile header */
  .mobile_header{
    height: 60px;
    // position: relative;
    .header_logo{
      width:150px;
    }
    .menu_icon{
      width:50px;
      height:50px;
      font-weight: 800;
      border-radius: 50%;
      color:$theme_color1;
      font-size: 30px;
    }
    .mobile_menu{
      position: absolute;
      top:60px;
      left:0;
      right:0;
      border-radius: 0 0 4px 4px;
      overflow: hidden;
     background:transparent;
      .mobile_menu_list{
        padding:10px;
        background: #00000090;
        
        .mobile_menu_tab{
          text-align: left;
          padding:5px 20px;
          font-size: 14px;
          
          .min_menu_list{
            padding-top:10px;
            .min_menu_tab{
              padding:5px 20px;
              opacity: 0.8;

            }
          }
        }
      }
    }
  }

}
</style>